export const getSecondsSinceDate = (startTime: Date) => {
    const currentTime = new Date();
    return (currentTime.getTime() - startTime.getTime()) / 1000;
};
